import { Card, CardContent, CardHeader, CardTitle } from '@agms/ui'
import { apiErrorStatus } from '../../hooks/useErrorHandler'
import { useAccountActivity } from '../../hooks/useAppointments'
import { formatAppointmentWhen } from '../../lib/formatAppointmentWhen'
import type { AccountAnchor } from '../../lib/api'

export function AccountActivityPanel({ anchor }: { anchor: AccountAnchor }) {
  const activityQuery = useAccountActivity(anchor)
  const title = anchor.kind === 'merchant' ? 'Merchant activity' : 'Lead activity'
  if (apiErrorStatus(activityQuery.error) === 403) {
    return null
  }

  const entries = activityQuery.data ?? []

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {activityQuery.isLoading && <p className="text-sm text-slate-500">Loading activity...</p>}
        {activityQuery.error && <p className="text-sm text-red-600" role="alert">Unable to load activity.</p>}
        {!activityQuery.isLoading && entries.length === 0 && (
          <p className="text-sm text-slate-500">No appointment activity yet.</p>
        )}
        <ol className="space-y-3">
          {entries.map((entry) => {
            const startsAt = entry.metadata?.starts_at
            const location = entry.metadata?.location
            const notes = entry.metadata?.notes
            return (
              <li key={entry.id} className="border-l-2 border-slate-200 pl-3">
                <p className="text-sm text-slate-800">{entry.summary}</p>
                <p className="text-xs text-slate-500">
                  {entry.user?.name ?? 'System'}
                  {entry.created_at ? ` · ${formatAppointmentWhen(entry.created_at)}` : ''}
                </p>
                {location && <p className="text-sm text-slate-700">{location}</p>}
                {notes && <p className="whitespace-pre-wrap text-sm text-slate-600">{notes}</p>}
                {startsAt && (
                  <p className="text-xs text-slate-500">In your time zone: {formatAppointmentWhen(startsAt)}</p>
                )}
              </li>
            )
          })}
        </ol>
      </CardContent>
    </Card>
  )
}
